/**
 * Packing slip route (§12.3, Task 5) — one printable A4 document per order. The
 * document body lives in <PackingSlipDoc/> (shared with the batch "print all
 * slips" run); this route just fetches and frames it. The order barcode (Code-128
 * of Order.id) is the scan key — scanning it opens the order at the bench.
 */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, type PackingSlipData } from "../../lib/api.js";
import { PrintFrame } from "./PrintFrame.js";
import { PackingSlipDoc } from "./PackingSlipDoc.js";

export function PackingSlip() {
  const { orderId } = useParams();
  const [data, setData] = useState<PackingSlipData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    if (!orderId) return;
    api
      .getPackingSlip(orderId)
      .then((d) => live && setData(d))
      .catch(() => live && setError("Could not load this packing slip."));
    return () => {
      live = false;
    };
  }, [orderId]);

  return (
    <PrintFrame title={data ? `Packing slip · ${data.order.name}` : "Packing slip"}>
      {error ? (
        <div className="doc">
          <p>{error}</p>
        </div>
      ) : !data ? (
        <div className="doc">
          <p>Loading…</p>
        </div>
      ) : (
        <PackingSlipDoc data={data} />
      )}
    </PrintFrame>
  );
}
